import { Col, Row } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { IndividualMetricCharts } from "shared/enums/IndividualMetricCharts";
import SingleChart from "./SingleChart";

interface MosaicChartsProps {
  individualMetrics?: any;
  filterIndividualMetrics?: any;
  loading: boolean;
}

const colors = [
  "#2E90FA",
  "#32D583",
  "#ADD55D",
  "#B692F6",
  "#75D1D2",
  "#E4A010",
  "#F05576",
  "#FF7514",
  "#ED955E",
  "#7D7F7D",
  "#9762D3",
  "#EB5D53",
];

const MosaicCharts: React.FC<MosaicChartsProps> = (props) => {
  const { individualMetrics, filterIndividualMetrics, loading } = props;
  const charts = Object.values(IndividualMetricCharts);
  const { t } = useTranslation("radar");

  const handleData = (
    individualMetrics: any,
    selectedMetric: any,
    filterIndividualMetrics: any
  ) => {
    const metrics = [];

    const categories =
      individualMetrics?.series
        ?.filter(
          (serie: any) =>
            filterIndividualMetrics === "all" ||
            moment().diff(moment(serie), "months") <
              (filterIndividualMetrics as number)
        )
        .map((serie: any) => new Date(moment(serie).toDate()).getTime()) || [];
    if (individualMetrics) {
      metrics.push({
        name: t(`pages.ArtistProfile.${selectedMetric}`),
        data: individualMetrics?.data[selectedMetric].slice(
          individualMetrics?.series.length - categories.length
        ),
      });
    }

    return {
      metrics,
      categories,
    };
  };

  return (
    <Row gutter={[72, 64]} style={{ padding: 64 }}>
      {charts.map((item, index) => {
        const data = handleData(
          individualMetrics,
          item,
          filterIndividualMetrics
        );
        return (
          <Col xs={12}>
            <SingleChart
              individualMetricData={data.metrics}
              individualMetricsCategories={data.categories}
              individualMetrics={individualMetrics}
              filterIndividualMetrics={filterIndividualMetrics}
              selectedMetric={item}
              color={[colors[index]]}
              colorText={colors[index]}
              title={t(`pages.ArtistProfile.${item}`)}
              loading={loading}
            />
          </Col>
        );
      })}
    </Row>
  );
};

export default MosaicCharts;
